export default __webpack_public_path__ + "static/media/Mark-5-Suit-06.e61c88b1.jpg";